// src/Admin/AdminZones.jsx
import React, { useEffect, useMemo, useState } from "react";
import CityField from "../components/CityField"; // <-- ADATTA se sta altrove
import {
    adminListZones,
    adminGetZoneSuppliers,
    adminAddZoneSupplier,
    adminRemoveZoneSupplier,
    adminDeleteZone,
} from "./adminApi";
import "./AdminZones.css";

function normComune(s) {
    return String(s || "").trim();
}

export default function AdminZones() {
    const tkn = localStorage.getItem("token");

    const [city, setCity] = useState("");
    const [provincia, setProvincia] = useState("");
    const [cap, setCap] = useState("");
    const [confirmed, setConfirmed] = useState(false);

    const [loadingLists, setLoadingLists] = useState(false);
    const [errLists, setErrLists] = useState("");

    const [linked, setLinked] = useState([]);
    const [unlinked, setUnlinked] = useState([]);

    const [zonesLoading, setZonesLoading] = useState(false);
    const [zonesErr, setZonesErr] = useState("");
    const [zones, setZones] = useState([]);

    const [drag, setDrag] = useState(null); // { id, from: "linked"|"unlinked" }
    const selectedComune = useMemo(() => normComune(city), [city]);

    async function reloadZonesTable() {
        setZonesLoading(true);
        setZonesErr("");
        try {
            const data = await adminListZones(tkn);
            setZones(data);
        } catch (e) {
            setZonesErr(e.message || "Errore caricamento zone");
        } finally {
            setZonesLoading(false);
        }
    }

    async function loadComuneLists(c) {
        const comune = normComune(c);
        if (!comune) return;

        setLoadingLists(true);
        setErrLists("");
        try {
            const data = await adminGetZoneSuppliers(comune, tkn);
            setLinked(Array.isArray(data.linked) ? data.linked : []);
            setUnlinked(Array.isArray(data.unlinked) ? data.unlinked : []);
        } catch (e) {
            setErrLists(e.message || "Errore caricamento fornitori");
            setLinked([]);
            setUnlinked([]);
        } finally {
            setLoadingLists(false);
        }
    }

    useEffect(() => {
        reloadZonesTable();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (confirmed && selectedComune) {
            loadComuneLists(selectedComune);
        } else {
            setLinked([]);
            setUnlinked([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [confirmed, selectedComune]);

    async function doAddSupplier(supplier) {
        if (!selectedComune || !confirmed) return;

        // optimistic
        setUnlinked((p) => p.filter((x) => x.id !== supplier.id));
        setLinked((p) => [...p, supplier].sort((a, b) => (a.nome || "").localeCompare(b.nome || "")));

        try {
            await adminAddZoneSupplier(selectedComune, {
                fornitoreId: supplier.id,
                comune: selectedComune,
                provincia,
                cap,
            }, tkn);
            await reloadZonesTable();
        } catch (e) {
            // rollback (semplice: ricarico liste)
            setErrLists(e.message || "Errore associazione");
            await loadComuneLists(selectedComune);
        }
    }

    async function doRemoveSupplier(supplier) {
        if (!selectedComune || !confirmed) return;

        // optimistic
        setLinked((p) => p.filter((x) => x.id !== supplier.id));
        setUnlinked((p) => [...p, supplier].sort((a, b) => (a.nome || "").localeCompare(b.nome || "")));

        try {
            await adminRemoveZoneSupplier(selectedComune, supplier.id, tkn);
            await reloadZonesTable();
        } catch (e) {
            setErrLists(e.message || "Errore disassociazione");
            await loadComuneLists(selectedComune);
        }
    }

    async function doDeleteComune() {
        if (!selectedComune || !confirmed) return;
        if (!window.confirm(`Eliminare tutte le associazioni per "${selectedComune}"?`)) return;

        try {
            await adminDeleteZone(selectedComune, tkn);
            setLinked([]);
            setUnlinked([]);
            await reloadZonesTable();
        } catch (e) {
            setErrLists(e.message || "Errore eliminazione comune");
        }
    }

    function onDropTo(target) {
        if (!drag) return;
        const { id, from } = drag;

        if (from === target) return;

        if (from === "unlinked" && target === "linked") {
            const s = unlinked.find((x) => x.id === id);
            if (s) doAddSupplier(s);
        }
        if (from === "linked" && target === "unlinked") {
            const s = linked.find((x) => x.id === id);
            if (s) doRemoveSupplier(s);
        }
    }

    return (
        <div className="az-page">
            <h1 className="az-h1">Zone fornitori</h1>

            {/* TOP */}
            <div className="az-card">
                <div className="az-topGrid">
                    <div className="az-city">
                        <CityField
                            label="Comune"
                            value={city}
                            provinciaValue={provincia}
                            capValue={cap}
                            enabled={true}
                            hardConfirm={true}
                            confirmed={confirmed}
                            setConfirmed={setConfirmed}
                            onChangeCity={(v) => {
                                setCity(v);
                                // tu decidi se resettare provincia/cap: qui li pulisco quando scrivi
                                setProvincia("");
                                setCap("");
                            }}
                            onApplyCity={({ name, provincia: pv, cap: cp }) => {
                                setCity(name);
                                setProvincia(pv || "");
                                setCap(cp || "");
                                setConfirmed(true);
                            }}
                        />
                        <div className="az-cityMeta">
                            {confirmed && selectedComune ? (
                                <>
                                    <span className="az-pill">{(provincia || "??").toUpperCase()}</span>
                                    {cap ? <span className="az-pill az-pill--muted">{cap}</span> : null}
                                </>
                            ) : (
                                <span className="az-help">Seleziona un comune dall’elenco</span>
                            )}
                        </div>

                        <div className="az-cityActions">
                            <button
                                className="az-btn az-btn--danger"
                                onClick={doDeleteComune}
                                disabled={!confirmed || !selectedComune}
                                title="Elimina l’intero comune (tutte le associazioni)"
                            >
                                Elimina comune
                            </button>
                        </div>
                    </div>

                    <div
                        className="az-col"
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={() => onDropTo("linked")}
                    >
                        <div className="az-colHead">
                            <h3 className="az-h3">Fornitori abilitati</h3>
                            <span className="az-badge">{linked.length}</span>
                        </div>

                        {loadingLists ? (
                            <div className="az-empty">Carico…</div>
                        ) : linked.length === 0 ? (
                            <div className="az-empty">Nessun fornitore abilitato</div>
                        ) : (
                            <ul className="az-list">
                                {linked.map((s) => (
                                    <li
                                        key={s.id}
                                        className={`az-item ${drag?.id === s.id ? "is-dragging" : ""}`}
                                        draggable
                                        onDragStart={() => setDrag({ id: s.id, from: "linked" })}
                                        onDragEnd={() => setDrag(null)}
                                    >
                                        <span className="az-name">{s.nome}</span>
                                        <button
                                            className="az-btn az-btn--sm az-btn--ghost"
                                            onClick={() => doRemoveSupplier(s)}
                                            title="Disassocia"
                                        >
                                            →
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>

                    <div
                        className="az-col"
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={() => onDropTo("unlinked")}
                    >
                        <div className="az-colHead">
                            <h3 className="az-h3">Altri fornitori</h3>
                            <span className="az-badge az-badge--muted">{unlinked.length}</span>
                        </div>

                        {loadingLists ? (
                            <div className="az-empty">Carico…</div>
                        ) : unlinked.length === 0 ? (
                            <div className="az-empty">Tutti assegnati (miracolo)</div>
                        ) : (
                            <ul className="az-list">
                                {unlinked.map((s) => (
                                    <li
                                        key={s.id}
                                        className={`az-item ${drag?.id === s.id ? "is-dragging" : ""}`}
                                        draggable
                                        onDragStart={() => setDrag({ id: s.id, from: "unlinked" })}
                                        onDragEnd={() => setDrag(null)}
                                    >
                                        <span className="az-name">{s.nome}</span>
                                        <button
                                            className="az-btn az-btn--sm az-btn--ghost"
                                            onClick={() => doAddSupplier(s)}
                                            title="Associa"
                                        >
                                            ←
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>

                {errLists ? <div className="az-err">{errLists}</div> : null}
            </div>
            {/* BOTTOM TABLE */}
            <div className="az-card">
                <div className="az-row">
                    <h2 className="az-h2">Riepilogo comuni</h2>
                </div>

                {zonesErr ? <div className="az-err">{zonesErr}</div> : null}

                {zonesLoading ? (
                    <div className="az-empty">Carico…</div>
                ) : zones.length === 0 ? (
                    <div className="az-empty">Nessun comune configurato</div>
                ) : (
                    <div className="az-tableGrid" role="region" aria-label="Riepilogo comuni">
                        {/* HEADER */}
                        <div className="az-gridHead az-gridRow">
                            <div className="az-cell az-cell--city">Città</div>
                            <div className="az-cell">Fornitore 1</div>
                            <div className="az-cell">Fornitore 2</div>
                            <div className="az-cell">Fornitore 3</div>
                            <div className="az-cell">Fornitore 4</div>
                            <div className="az-cell">Fornitore 5</div>
                            <div className="az-cell az-cell--actions" aria-label="Azioni" />
                        </div>

                        {/* ROWS */}
                        {zones.map((z) => {
                            const suppliers = Array.isArray(z.fornitori) ? z.fornitori : [];
                            const slots = suppliers.slice(0, 5);
                            while (slots.length < 5) slots.push(null);

                            return (
                                <div className="az-gridRow" key={z.comune_norm}>
                                    {/* CITTÀ */}
                                    <div className="az-cell az-cell--city">
                                        <div className="az-cityName">{z.comune}</div>
                                        <div className="az-muted">{z.count} fornitori</div>
                                    </div>

                                    {/* FORNITORI 1..5 */}
                                    {slots.map((s, idx) => (
                                        <div className="az-cell az-cell--supplier" key={`${z.comune_norm}-s${idx}`}>
                                            {s?.nome ? (
                                                <span className="az-supplierName" title={s.nome}>
                                                    {s.nome}
                                                </span>
                                            ) : (
                                                <span className="az-dash">—</span>
                                            )}
                                        </div>
                                    ))}

                                    {/* AZIONI */}
                                    <div className="az-cell az-cell--actions">
                                        <button
                                            className="az-iconBtn"
                                            title="Modifica"
                                            aria-label={`Modifica ${z.comune}`}
                                            onClick={() => {
                                                setCity(z.comune);
                                                setProvincia(z.provincia || "");
                                                setCap(z.cap || "");
                                                setConfirmed(true);
                                                window.scrollTo({ top: 0, behavior: "smooth" });
                                            }}
                                        >
                                            ✏️
                                        </button>

                                        <button
                                            className="az-iconBtn az-iconBtn--danger"
                                            title="Elimina"
                                            aria-label={`Elimina ${z.comune}`}
                                            onClick={async () => {
                                                if (!window.confirm(`Eliminare "${z.comune}" e tutte le associazioni?`)) return;
                                                try {
                                                    await adminDeleteZone(z.comune, tkn);
                                                    await reloadZonesTable();
                                                    if (normComune(z.comune) === selectedComune) {
                                                        setLinked([]);
                                                        setUnlinked([]);
                                                    }
                                                } catch (e) {
                                                    setZonesErr(e.message || "Errore eliminazione comune");
                                                }
                                            }}
                                        >
                                            🗑️
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
}
